import { List, ListItemText } from "@mui/material";
import { formatNumber } from "helpers/getNumberFormats";
import React from "react";

export const CountersComponent = ({ counters }) => {
  return (
    <List
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
        width: "100%",
      }}
    >
      {counters?.map((counter, index) => (
        <ListItemText
          key={index}
          primary={`${counter.label}:`}
          secondary={
            <>
              {counter.unit === "$" ? "$ " : ""}
              {formatNumber({ input: counter.value })}
              {counter.unit !== "$" ? ` ${counter.unit}` : ""}
            </>
          }
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 1,
            maxWidth: 250,
            minWidth: 150,
          }}
        />
      ))}
    </List>
  );
};
